module.exports = __webpack_public_path__ + "static/media/expert.42dd20ef.webp";